import { t } from 'i18next';
import React from 'react';
import useDetailTripPlan from '../detail-trip-plan.hooks';
import Accordion from '../../../../../../component/accordion/Accordion';
import DefaultPagination from '../../../../../../component/pagination/default-pagination';
import { Skeleton } from 'antd';

const TabOrderNotAssign = () => {
  const {
    listOrderNotAssign,
    isOpen,
    dataNotAssign,
    index,
    pageOrderNotAssign,
    limitOrderNotAssign,
    initiateOrderNotAssign,
    isSkeletonOrderNotAssign,
    clickCard,
    _handlePagination,
    _changeRowPerPage
  } = useDetailTripPlan();
  
  return (
    <div className='flex'>
      <div className="gap-[40px] mb-[24px]">
      {/* Tab Title */}
      <div className="w-[500px] mb-[24px]">
        <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
          {t("Order Not Assign Detail")}
        </h3>
      </div>

      {/* Tab Content / Accordion */}
      { isSkeletonOrderNotAssign ? (<Skeleton active />) : listOrderNotAssign?.map((el, i) => {
        return (
          <div id={i}>
            <Accordion
              onClick={() => clickCard(i, isOpen, el?.id)}
              index={i}
              i={index}
              isOpen={isOpen}
              address={`${el?.order_id} - ${el?.sub_district} , ${el?.district}`}
              body={
                <>
                  {isOpen === true && i === index ? (
                    <>
                      <div className="flex flex-col gap-[40px] ml-10">
                        <div>
                          <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                            {t("Order Detail")}
                          </h3>
                          <div className="flex">
                            {/* line one */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Company Profile")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                  {dataNotAssign?.company_profile_id ? dataNotAssign?.company_profile_id : '-'}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Customer ID")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.customer_id ? dataNotAssign?.customer_id : '-'}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Skill Set")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.skill_set_list ? dataNotAssign?.skill_set_list[0].skill_set_name : '-'}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Temperature Category")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.temperature_category_list ? dataNotAssign?.temperature_category_list[0].temperature_category_name : '-'}
                                </h4>
                              </div>
                            </div>
                            {/* line two */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[500px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Delivery Type")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.delivery_type ? dataNotAssign?.delivery_type : '-'}
                                </h4>
                              </div>
                              
                              <div className="w-[500px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Total Weight")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.total_weight ? dataNotAssign?.total_weight : '0'} kg
                                </h4>
                              </div>
                              <div className="w-[500px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Total Volume")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                  {dataNotAssign?.total_volume ? dataNotAssign?.total_volume : '0'} m<sup>3</sup>
                                </h4>
                              </div>
                              <div className="w-[500px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Price")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                  {dataNotAssign?.price ? "Rp" + dataNotAssign?.price : "Rp 0"}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col gap-[40px] ml-10">
                        <div>
                          <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                            {t("Customer Detail")}
                          </h3>
                          <div className="flex">
                            {/* line one */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("First Name")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                  {dataNotAssign?.customer_first_name ? dataNotAssign?.customer_first_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Last Name")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.customer_last_name ? dataNotAssign?.customer_last_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Email")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.customer_email ? dataNotAssign?.customer_email : "-"}
                                </h4>
                              </div>
                            </div>
                            {/* line two */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[500px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Phone")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.phone ? dataNotAssign?.phone : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Fax")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.fax ? dataNotAssign?.fax : "-"}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col gap-[40px] ml-10">
                        <div>
                          <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                            {t("Address Detail")}
                          </h3>
                          <div className="flex">
                            {/* line one */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Country")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.country_name ? dataNotAssign?.country_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Island")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.island_name ? dataNotAssign?.island_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Province")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.province_name ? dataNotAssign?.province_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("District")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.district_name ? dataNotAssign?.district_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Sub District")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.sub_district_name ? dataNotAssign?.sub_district_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Urban Village")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.urban_village_name ? dataNotAssign?.urban_village_name : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Address")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.address_name ? dataNotAssign?.address_name : "-"}
                                </h4>
                              </div>
                            </div>
                            {/* line two */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[500px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Neighbourhood")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.neighbour ? dataNotAssign?.neighbour : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Hamlet")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.hamlet ? dataNotAssign?.hamlet : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Postal Code")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.postal_code ? dataNotAssign?.postal_code : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Lattitude")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.latitude ? dataNotAssign?.latitude : "-"}
                                </h4>
                              </div>
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Longtitude")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                {dataNotAssign?.longitude ? dataNotAssign?.longitude : "-"}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col gap-[40px] ml-10">
                        <div>
                          <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                            {t("Order Notes")}
                          </h3>
                          <div className="flex">
                            {/* line one */}
                            <div className="gap-[40px] mb-[24px]">
                              <div className="w-[400px] mb-[24px]">
                                <label className="font-roboto text-[14px] text-[#818181]">
                                  {t("Delivery Notes")}
                                </label>
                                <h4 className="font-roboto text-[20px] text-[#424242]">
                                  {dataNotAssign?.delivery_notes ? dataNotAssign?.delivery_notes : '-'}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </>
                  ) : null}
                </>
                }
              />
            </div>
          );
        })}

        <DefaultPagination
          idLimit="ddlrowsperpagedeliveryassociatetripplanning"
          title={t("COMMON:ROW_PAGE")}
          current={pageOrderNotAssign}
          handlePaging={(evt) => { _handlePagination(evt, 'order_not_assign') }}
          initiate={initiateOrderNotAssign}
          selectedRowPage={limitOrderNotAssign}
          changeRowPerPage={(evt) => { _changeRowPerPage(evt, 'order_not_assign') }}
        />
      </div>
    </div>
  );
}

export default TabOrderNotAssign;